// @ts-nocheck
import React from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import KwPanel from '../../common/KwPanel';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import FormToggleBool from '../../common/FormToggleBool';
import Button from '../../common/Button';
import ConfirmationHeader from '../../common/ConfirmationHeader';
import { useTranslation, Trans } from 'react-i18next';
import { unarchiveGameSku } from '../../../api/gameApi';

function Unarchive({ done, skuId, gameId, cancel }) {
  const { handleSubmit, control } = useForm();
  const { t } = useTranslation();

  const handleUnarchive = (data) => {
    unarchiveGameSku(gameId, skuId, data.restorePendingRequests)
      .then(() => {
        toast.success(t('SKU successfully unarchived'));
        done();
      })
      .catch(() => {
        toast.error(t('Failed to unarchive SKU'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Unarchive confirmation')}
      cancel={cancel}
      done={done}
    >
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <p>
          {t(
            'Once the sku is unarchived, users will be able to request keys again.'
          )}
        </p>
        <p>
          <Trans i18nKey="unarchiveConfirmation" components={{ bold: <b /> }}>
            You can also <bold>'Restore pending requests'</bold> from before the
            SKU was archived.
          </Trans>
        </p>
        <FormToggleBool
          control={control}
          name="restorePendingRequests"
          label={t('Restore pending requests?')}
          defaultValue={false}
        />
        <hr />
        <Button
          className="btn btn-primary me-2"
          onClick={handleSubmit(handleUnarchive)}
          text={t('Yes, unarchive the sku')}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}



export default Unarchive;
